import Api from "./Api";

export default {
  getUnreadMessagesCounter(id) {
    return Api().get(`/count-unread-messages/${id}`);
  },
  getMessagesDetails(payload) {
    return Api().get(`/message/${payload.companyId}/${payload.id}`);
  },
};